import type { FaireProductEntity } from "../../entity_types/product";

export const p_augvy3h652: FaireProductEntity = {
  token: "p_augvy3h652",
  type: "product",
  name: "paint swatch notecard",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/5571af0a00fe1a6f08124253a4f656e11510380cba3d4c5b8611c1f8a7e2473b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f9ddff16bdb2aba47da1d40473e17418fb4371777d09b1ad5ea230541162f9f4.jpeg",
    "https://cdn.faire.com/fastly/264fe39fb2785b84f03b3483f032e84213cdc9c8e2c4df6fa8fc18f08c76eb5f.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "Send sweet greetings for any occasion with the paint swatch notecards. These showcase charming watercolor paint swatches and bring a touch of cheer to your thank you notes, get well wishes, and more.\n\n• set of eight (or single) folded cards + envelopes\n• blank inside\n• 5.5 inch x 4.25 inch\n• printed on 120lb superfine paper\n• original artwork by Emily Lex",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-28T05:30:10.538Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
